module.exports = __webpack_public_path__ + "assets/img/1_1736_big.d011d3bf.jpg";